import { loadLocalModule } from "./nodeLoader";

// Shape layers the AE exports render instead of writing them as vectors (Wiggle Paths, Zig Zag...) are traced here,
// with the panel's own Node: the users have no Node installed, so the exports only write the renders and their
// description. The tracers come from src/utils/nodeModules (copies of the ae2-authors repository modules); the shared
// outline tracer (traceShapeLayers.traceSlots) is passed in, the panel loads every module as a single source.

const loadTraceSlots = () => {
  const module = loadLocalModule("traceShapeLayers");
  if (!module || typeof module.traceSlots !== "function") throw new Error("traceShapeLayers is not available");
  return module.traceSlots;
};

// Motion (AE2FCP): the .motn files AE2FCP returns get their traced shapes (AE2M5/traceMotionShapes.js); entries are
// { motn, trace } (trace: the trace.json in the extension's temp folder, removed with the renders after).
// Returns the number of traced layers.
export const traceMotionFiles = (files) => {
  if (!files || !files.length) return 0;
  const module = loadLocalModule("traceMotionShapes");
  if (!module || typeof module.traceMotionFile !== "function") throw new Error("traceMotionShapes is not available");
  const traceSlots = loadTraceSlots();
  let layers = 0;
  for (const file of files) {
    const r = typeof file === "string"
      ? module.traceMotionFile(file, { traceSlots })
      : module.traceMotionFile(file.motn, { traceSlots, tracePath: file.trace });
    layers += (r && r.layers) || 0;
  }
  return layers;
};

// DaVinci Resolve (exportDrMacro): the parsed export result with aeTrace gets the traced shapes in its Fusion texts,
// in place (AE2DR/traceFusionShapes.js).
export const traceFusionExport = (data) => {
  if (!data || !data.aeTrace) return data;
  const module = loadLocalModule("traceFusionShapes");
  if (!module || typeof module.traceFusionData !== "function") throw new Error("traceFusionShapes is not available");
  module.traceFusionData(data, { traceSlots: loadTraceSlots() });
  return data;
};
